import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const DigiProtectedRoute = () => {
  const loggedInUser = localStorage.getItem("userId");
  const user = JSON.parse(loggedInUser);
  return user === null ? <Navigate to="/login" replace /> : <Outlet />;
};

export default DigiProtectedRoute;
